import { render } from "./UserModal.vue?vue&type=template&id=5300aa39&ts=true"
import script from "./UserModal.vue?vue&type=script&lang=ts"
export * from "./UserModal.vue?vue&type=script&lang=ts"

import "./UserModal.vue?vue&type=style&index=0&id=5300aa39&lang=scss"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__